<div class="form-checkbox" [class.disabled]="disabled()" (click)="toggle()">
    @if(isChecked()) {
        <img priority="true"
            ngSrc="/assets/img/icons/checkbox_checked.svg"
            width="16" height="16" alt="" />
    }
</div>
